import { combineReducers } from "redux";
import userSlice from "./userSlice";
import adminClientsSlice from "./adminClientsSlice";
import servicePlansSlice from "./servicePlansSlice";
import mmymSlice from "./mmymSlice";
import leadSlice from "./leadSlice";
import workerSlice from "./workerSlice";
import vehicleSlice from "./vehicleSlice";
import subUserSlice from "./subUserSlice";
import surveyDiarySlice from "./surveyDiarySlice";
import leadSurveySlice from "./leadSurveySlice";
import roleSlice from "./roleSlice";
import customerSlice from "./customerSlice";
import clientConfirmationSlice from "./clientConfirmationSlice";
import documentSlice from "./documentSlice";
import invoiceSlice from "./invoiceSlice";
import workDiarySlice from "./workDiarySlice";
import paymentSlice from "./paymentSlice";
import feedbackSlice from "./feedbackSlice";
import customerFeedbackSlice from "./customerFeedbackSlice";
import  templateSlice from "./templateSlice";
import referrerSlice from "./referrerSlice";
import adminCreationSlice from "./adminCreationSlice";
import  publicSlice from "./publicSlice";
import htmlTemplateSlice from "./htmlTemplateSlice";
import dashboardSlice from "./dashboardSlice";
import materialSlice from "./materialSlice";
import assignWorkerSlice from "./assignWorkerSlice";
import quickBookSlice  from "./quickBookSlice";
import subContractorSlice from "./subContractor";
import saleSlice  from "./saleSlice";
import signOffTaskSlice from "./signOffTaskSlice";
import complaintSlice  from "./complaintSlice";
import emailTemplateSlice from "./emailTemplateSlice";
import smsTemplateSlice  from "./smsTemplateSlice";
import settingSlice from "./settingSlice";
import reviewSlice from "./reviewSlice";
import storageSettingSlice from "./storageSettingSlice";
import storageSlice from "./storageSlice";
import contractStorageSlice from "./contractStorageSlice";


const reducers = combineReducers({
    user: userSlice,
    adminClients: adminClientsSlice,
    servicePlans: servicePlansSlice,
    lead:leadSlice,
    mmym: mmymSlice,
    worker:workerSlice,
    vehicle:vehicleSlice,
    subUser:subUserSlice,
    surveyDiary: surveyDiarySlice,
    leadSurvey: leadSurveySlice,
    role:roleSlice,
    customer: customerSlice,
    confirmation:clientConfirmationSlice,
    document:documentSlice,
    invoice:invoiceSlice,
    payment :paymentSlice,
    workDiary:workDiarySlice,
    feedback:feedbackSlice,
    customerFeedback:customerFeedbackSlice,
    template:templateSlice,
    referrer:referrerSlice,
    adminCreation:adminCreationSlice,
    public:publicSlice,
    htmlTemplate:htmlTemplateSlice,
    dashboard:dashboardSlice,
    material:materialSlice,
    assignWorker:assignWorkerSlice,
    quickBook:quickBookSlice,
    subContractor:subContractorSlice,
    sale:saleSlice,
    signOffTask:signOffTaskSlice,
    complaint: complaintSlice,
    emailTemplates: emailTemplateSlice,
    smsTemplate: smsTemplateSlice,
    setting:settingSlice,
    review:reviewSlice,
    storageSetting: storageSettingSlice,
    storage:storageSlice,
    contractStorage:contractStorageSlice
})

export default reducers;